import SvgIcon from "@mui/material/SvgIcon";

export const LogoutIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 25" {...props}>
      <path
        d="M15.2405 22.2705H15.1105C10.6705 22.2705 8.5305 20.5205 8.1605 16.6005C8.1205 16.1905 8.4205 15.8205 8.8405 15.7805C9.2505 15.7405 9.6205 16.0505 9.6605 16.4605C9.9505 19.6005 11.4305 20.7705 15.1205 20.7705H15.2505C19.3205 20.7705 20.7605 19.3305 20.7605 15.2605V8.74047C20.7605 4.67047 19.3205 3.23047 15.2505 3.23047H15.1205C11.4105 3.23047 9.9305 4.42047 9.6605 7.62047C9.6105 8.03047 9.2705 8.34047 8.8405 8.30047C8.4205 8.27047 8.1205 7.90047 8.1505 7.49047C8.4905 3.51047 10.6405 1.73047 15.1105 1.73047H15.2405C20.1505 1.73047 22.2505 3.83047 22.2505 8.74047V15.2605C22.2505 20.1705 20.1505 22.2705 15.2405 22.2705Z"
        fill="currentColor"
      />
      <path
        d="M14.88 12.75H2C1.59 12.75 1.25 12.41 1.25 12C1.25 11.59 1.59 11.25 2 11.25H14.88C15.29 11.25 15.63 11.59 15.63 12C15.63 12.41 15.3 12.75 14.88 12.75Z"
        fill="currentColor"
      />
      <path
        d="M12.6498 16.0998C12.4598 16.0998 12.2698 16.0298 12.1198 15.8798C11.8298 15.5898 11.8298 15.1098 12.1198 14.8198L14.9398 11.9998L12.1198 9.17984C11.8298 8.88984 11.8298 8.40984 12.1198 8.11984C12.4098 7.82984 12.8898 7.82984 13.1798 8.11984L16.5298 11.4698C16.8198 11.7598 16.8198 12.2398 16.5298 12.5298L13.1798 15.8798C13.0298 16.0298 12.8398 16.0998 12.6498 16.0998Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
